import React, { useState, useEffect } from 'react';
import Button from 'components/Button';
import { CrossIcon } from 'assets/icons';
import { ClientInfoModalContainer } from './styles';
import { useNavigate } from 'react-router-dom';
import ModalBookingCancel from 'screens/ModalBookingCancel';
import ModalCancelConfirm from 'screens/ModalCancelConfirm';
import ModalCheckOut from 'screens/ModalCheckOut';
import ModalCheckOutConfirm from 'screens/ModalCheckOutConfirm';
import moment from 'moment-timezone';
import { 
  TIME_ZONE,
  DEFAULT_CHECK_IN_HOUR,
  DEFAULT_CHECK_IN_MINUTE,
  DEFAULT_CUT_OFF_HOUR,
  DEFAULT_CUT_OFF_MINUTE
} from "constants/constant";

const ClientModal = ({
  clientModalOpen,
  setClientModalOpen,
  bookingDetailsData,
  setBookingDetailsData,
  setItems
}) => {

  const navigate = useNavigate(); 
  const [top, setTop] = useState(50)
  const [confirmIsOpen, setConfirmIsOpen] = useState(false)
  const [cancelRoomParams, setCancelRoomParams] = useState({})

  //ModalCheckOut
  const [checkOutConfirmIsOpen, setCheckOutConfirmIsOpen] = useState(false)
  const [checkOutBookings, setCheckOutBookings] = useState([])
  const checkedInBookings = bookingDetailsData?.bookingByID?.group?.bookings?.filter(booking => booking.status === 'CHECKED_IN')

  useEffect(() => {
    const onScroll = () => {
      if(window.scrollY<50) {
        setTop(50-window.scrollY);
      } else {
        setTop(0)
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    // clean up code
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <ClientInfoModalContainer open={clientModalOpen} position={top}>
      <div>
        <CrossIcon
          className='closeButton'
          onClick={() => {
            setClientModalOpen(false);
          }}
        />
      </div>
      <div className="clientButtonSection">
        <div className="clientName">
          {bookingDetailsData?.bookingByID?.fullName}
        </div>
        <div className="buttonsContainer">
          <Button
            mainPage
            additionalstyle={`
              width: 80px;
            `}
            onClick={(event) => {
              if (event.metaKey || event.ctrlKey) {
                // Open new tab with absolute URL
                window.open(`https://pms.rookhotel.com/booking-details/${bookingDetailsData?.bookingByID?.group.groupId}`, '_blank', 'noopener,noreferrer');
              } else {
                // Normal navigation
                navigate(`/booking-details/${bookingDetailsData?.bookingByID?.group.groupId}`);
              }
            }}
          >
            Manage
          </Button>
          {bookingDetailsData?.bookingByID?.group.status === "PENDING"? (
            <Button
              mainPage
              onClick={(event) => {
                const earlyCheckIn = (moment().tz(TIME_ZONE) < moment(bookingDetailsData?.bookingByID?.checkInDate).tz(TIME_ZONE).set({ hour: DEFAULT_CHECK_IN_HOUR, minute: DEFAULT_CHECK_IN_MINUTE, second: 0 })) && (moment(bookingDetailsData?.bookingByID?.checkInDate).tz(TIME_ZONE).set({ hour: DEFAULT_CUT_OFF_HOUR, minute: DEFAULT_CUT_OFF_MINUTE, second: 0 }) <= moment().tz(TIME_ZONE))
  
                if (earlyCheckIn) {
                  if (event.metaKey || event.ctrlKey) {
                    // Open new tab with absolute URL
                    window.open(`https://pms.rookhotel.com/group-check-in/early-check-in/${bookingDetailsData?.bookingByID?.group.groupId}`, '_blank', 'noopener,noreferrer');
                  } else {
                    // Normal navigation
                    navigate(`/group-check-in/early-check-in/${bookingDetailsData?.bookingByID?.group.groupId}`);
                  }
                } else {
                  if (event.metaKey || event.ctrlKey) {
                    // Open new tab with absolute URL
                    window.open(`https://pms.rookhotel.com/group-check-in/confirm-identity/${bookingDetailsData?.bookingByID?.group.groupId}`, '_blank', 'noopener,noreferrer');
                  } else {
                    navigate(`/group-check-in/confirm-identity/${bookingDetailsData?.bookingByID?.group.groupId}`);
                  }
                }
              }}
              additionalstyle={`
                width: 82px;
                margin-left: 8px;
              `}
            >
              Check In
            </Button>
          ) : null}
          {bookingDetailsData?.bookingByID?.group.status === "CHECKED_IN" ? (
            checkedInBookings?.length > 1 ? (
              <ModalCheckOut
                buttonLabel="Check Out"
                buttonStyle={`
                  width: 90px;
                  margin-left: 8px;
                `}
                checkedInBookings={checkedInBookings}
                checkOutBookings={checkOutBookings}
                setCheckOutBookings={setCheckOutBookings}
                setCheckOutConfirmIsOpen={setCheckOutConfirmIsOpen}
              />
            ): (
              <ModalCheckOutConfirm
                buttonLabel="Check Out"
                buttonStyle={`
                  width: 90px;
                  margin-left: 8px;
                `}
                isOpen={checkOutConfirmIsOpen}
                setIsOpen={setCheckOutConfirmIsOpen}
                checkOutBookings={checkedInBookings}
                setItems={setItems}
                setBookingDetailsData={setBookingDetailsData}
              />
            )
          ) : null}
          <ModalBookingCancel
            danger
            checkedIn={bookingDetailsData?.bookingByID?.status === 'CHECKED_IN'}
            buttonLabel="Cancel"
            buttonStyle={`
              width: 70px;
              margin-left: 8px;
            `}
            bookingId={bookingDetailsData?.bookingByID?.bookingId}
            setConfirmIsOpen={setConfirmIsOpen}
            setCancelRoomParams={setCancelRoomParams}
            roomNumber={bookingDetailsData?.bookingByID?.roomBookings?.[0].room.roomNumber}
          />
        </div>
      </div>
      <ModalCancelConfirm
        isOpen={confirmIsOpen}
        setIsOpen={setConfirmIsOpen}
        cancelRoomParams={cancelRoomParams}
        setCancelRoomParams={setCancelRoomParams}
        roomNumber={bookingDetailsData?.bookingByID?.roomBookings?.[0].room.roomNumber}
        bookingId={bookingDetailsData?.bookingByID?.bookingId}
        setItems={setItems}
        setBookingDetailsData={setBookingDetailsData}
      />
      {checkedInBookings?.length > 1 && (
        <ModalCheckOutConfirm
          isOpen={checkOutConfirmIsOpen}
          setIsOpen={setCheckOutConfirmIsOpen}
          checkOutBookings={checkOutBookings}
          setItems={setItems}
          setBookingDetailsData={setBookingDetailsData}
        />
      )}
      <div>
        <div className="clientInfoItem">
          <div className="infoTitle">Confirmation number</div>
          <div className="info">
            {bookingDetailsData?.bookingByID?.group.primaryBookingCode}
          </div>
        </div>
        <div className="clientInfoItem">
          <div className="infoTitle">Status</div>
          <div className="info">{bookingDetailsData?.bookingByID?.status}</div>
        </div>
        <div className="clientInfoItem">
          <div className="infoTitle">Group</div>
          <div className="info">
            {bookingDetailsData?.bookingByID?.group.name}
          </div>
        </div>
        <div className="clientInfoItem">
          <div className="infoTitle">Arrival</div>
          <div className="info">
            {moment(
              bookingDetailsData?.bookingByID?.checkedInAt ||
                bookingDetailsData?.bookingByID?.checkInDate
            ).tz(TIME_ZONE).format("MMM Do YYYY h:mm A")}
          </div>
        </div>
        <div className="clientInfoItem">
          <div className="infoTitle">Departure</div>
          <div className="info">
            {moment(
              bookingDetailsData?.bookingByID?.checkedOutAt ||
                bookingDetailsData?.bookingByID?.checkOutDate
            ).tz(TIME_ZONE).format("MMM Do YYYY h:mm A")}
          </div>
        </div>
        <div className="clientInfoItem">
          <div className="infoTitle">Room Type</div>
          <div className="info">
            {
              bookingDetailsData?.bookingByID?.roomBookings?.[0].room.roomType
                .name
            }
          </div>
        </div>
        <div className="clientInfoItem">
          <div className="infoTitle">Assigned room</div>
          <div className="info">
            {bookingDetailsData?.bookingByID?.roomBookings?.[0].room.roomNumber}
          </div>
        </div>
        <div className="clientInfoItem">
          <div className="infoTitle">Rate</div>
          <div className="info">
            ${bookingDetailsData?.bookingByID?.roomBookings?.[0].pricePerNight}
          </div>
        </div>
        <div className="clientInfoItem">
          <div className="infoTitle">Origin</div>
          <div className="info">Email</div>
        </div>
        <div className="clientInfoItem">
          <div className="infoTitle">Created</div>
          <div className="info">
            {moment(bookingDetailsData?.bookingByID?.createdAt)
            .tz(TIME_ZONE)
            .format("MMM Do YYYY h:mm A")}
          </div>
        </div>
      </div>
    </ClientInfoModalContainer>
  );
};

export default ClientModal;
